import { ReactElement } from 'react';

import { SkeletonItem } from '../LoadingItem';

import styles from './styles.module.scss';

export function LoadingComponent(): ReactElement {
  return (
    <div className={styles.loadingContainer}>
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
    </div>
  );
}
